module.exports = __webpack_public_path__ + "TrapsAndTrinkets.jpg?1c2a2a3bd0cd67a473dad0195f84cf79";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/TrapsAndTrinkets.jpg
// module id = 557
// module chunks = 0